module.exports = __webpack_public_path__ + "img/solution-data-logo12.d6273f52.png";